export function isAiModelForm(apiType: string | undefined | null): boolean {
  return apiType === 'ai_model'
}

export function parseExtraConfigJson(
  raw: string,
): Record<string, unknown> | undefined {
  const trimmed = raw.trim()
  if (!trimmed) {
    return undefined
  }
  const parsed = JSON.parse(trimmed) as unknown
  if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
    throw new SyntaxError('extra_config must be a JSON object')
  }
  return parsed as Record<string, unknown>
}
